<template>
  <v-card
    class="left-vertical-card"
    height="500"
  >
    <div class="d-flex bg-titre">
      <div class="secondary--text align-self-center pl-3 titre-h3 mr-auto">
        Nouvelle culture
      </div>

      <v-btn
        class="align-self-center"
        text
        @click="onClose()"
      >
        <v-icon color="secondary">
          mdi-close
        </v-icon>
      </v-btn>
    </div>
    <div class="d-flex flex-column mt-6 mx-4">
      <BaseTreeSelect
        :selected="typeCultureSelectedID"
        :tree="arborescenceTypeCultureFormatee"
        class="tree-select mb-5"
        label="Type de culture"
        searchable
        @change="selectCulture"
      />
    </div>
    <v-card-actions class="pa-4">
      <v-spacer />
      <AgrButton
        color="primary darken-1"
        outlined
        @click="onClose()"
      >
        Annuler
      </AgrButton>
      <AgrButton
        :disabled="!isValid"
        color="primary darken-1"
        @click="save"
      >
        Valider
      </AgrButton>
    </v-card-actions>
  </v-card>
</template>

<script>
import { AgrButton } from '@agrial/ui'
import BaseTreeSelect from '@/components/common/base-treeselect.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AjoutCultureModal',
  components: {AgrButton, BaseTreeSelect },
  props: {
    cultures: {
      type: Array,
      required: true
    },
  },

  data () {
    return {
      typeCultureSelectedID: null
    }
  },

  computed: {
    ...mapGetters({
      arborescenceTypeCulture: 'application/arborescenceTypeCulture',
    }),
    listeCodeTypeCultureSelectionnes () {
      return this.cultures.map(culture => culture.code)
    },
    arborescenceTypeCultureFiltree () {
      const cloneArborescence = Array.from(this.arborescenceTypeCulture)
      cloneArborescence.forEach(typeCulture => this.filtrerArborescence(typeCulture))
      return cloneArborescence
    },
    arborescenceTypeCultureFormatee () {
      const cloneArborescence = Array.from(this.arborescenceTypeCultureFiltree)
      return cloneArborescence.map(typeCulture => this.formatArborescence(typeCulture, 0))
    },
    isValid () {
      return this.typeCultureSelectedID != null
    }
  },

  created () {
    this.fetchArborescenceTypeCulture()
  },

  methods: {
    ...mapActions({
      fetchArborescenceTypeCulture: 'application/fetchArborescenceTypeCulture'
    }),
    selectCulture (id) {
      this.typeCultureSelectedID = id
    },
    onClose () {
      this.$emit('close')
    },
    save () {
      this.$emit('save', this.typeCultureSelectedID)
    },
    //ATTENTION: Méthodes récursives
    filtrerArborescence (noeudArborescence) {
      noeudArborescence.typeCultureFils.forEach(noeudFils => this.filtrerArborescence(noeudFils))
      //un noeud type de culture est désactivé:
      //SI tous ses fils le sont OU le noeud est déjà selectionné
      noeudArborescence.isDisabled =
        (noeudArborescence.typeCultureFils.length && noeudArborescence.typeCultureFils.every(noeudFils => noeudFils.isDisabled)) ||
        this.typeCultureSelectedID === noeudArborescence.id ||
        this.listeCodeTypeCultureSelectionnes.includes(noeudArborescence.code)
    },
    formatArborescence (noeudArborescence, hauteur) {
      const noeudFormate = {
        id: noeudArborescence.id,
        label: noeudArborescence.nom,
        isDisabled: noeudArborescence.isDisabled,
        hauteur
      }
      const children = noeudArborescence.typeCultureFils.map(fils => this.formatArborescence(fils, hauteur+1))

      if (children.length) {
        noeudFormate.children = children
      }
      return noeudFormate
    },
    findNoeud (noeudArborescence, idATrouver) {
      const typeCultureTrouve = noeudArborescence.typeCultureFils.map(fils => this.findNoeud(fils, idATrouver)).find(searchResult => searchResult !== null)

      //Si typeCultureTrouve n'est pas undefined, le type de culture a été trouvé dans les fils du noeuds courant
      if (typeCultureTrouve !== undefined) {
        return typeCultureTrouve
      //Si l'id du noeud courant est égal à l'idATrouver, le noeud courant est renvoyé, sinon null (null => typeCulture pas trouvé dans le noeud courant)
      } else if (noeudArborescence.id === idATrouver) {
        return noeudArborescence
      } else {
        return null
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.left-vertical-card {
  border-radius: 0 !important;
}

.bg-titre {
  height: 70px;
  background-color: #f1f2f5;
}
</style>
